import { COUNTRY_TIMEZONES } from '@shared/constants/timezones';
import { CountryCode } from '@shared/types/utils/timezone.types';
import dayjs from 'dayjs';
import { getCountryCodeByPhoneNumber } from './country.helper';

// TypeScript preserves autocomplete for the literal values
// while still allowing any string
export const getTimezoneByCountryCode = (countryCode: CountryCode | (string & {})) => {
  return COUNTRY_TIMEZONES[countryCode as CountryCode]?.timezone;
};

export const getCurrentDateFromTimezone = (timezone: string) => {
  if (!timezone) return;
  try {
    const date = dayjs.tz(dayjs(), timezone);
    return date;
  } catch (error) {
    console.error(error);
  }
};

export const getCurrentDateFromPhoneNumber = (phoneNumber: string) => {
  const countryCode = getCountryCodeByPhoneNumber(phoneNumber);
  if (!countryCode) return '';

  const timezone = getTimezoneByCountryCode(countryCode);
  const date = getCurrentDateFromTimezone(timezone);

  return date ?? '';
};
